export default __webpack_public_path__ + "static/media/Gotham-BookItalic.17759c7b.otf";